import { RootState } from '@client/redux/types';
import { NAMESPACE } from './constants';

// TODO Think of namings
export const getTrackingData = (state: RootState) => state[NAMESPACE].data;
